import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const RemoveIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="x-close" {...props} />;
};

export { RemoveIcon };
